import { trigger, transition, style, query as q, group, animate, AnimationMetadata, animateChild } from '@angular/animations';

// tslint:disable-next-line: no-shadowed-variable
const query = (style: string, animate: AnimationMetadata | AnimationMetadata[], optional = { optional: true }) =>
  q(style, animate, optional);

//export const routerFade = trigger('routerFade', [
//  transition('* <=> *', [
//    query(':enter, :leave', style({ position: 'fixed', width: '100%', height: '100%' })),
//    group([
//      query(':enter', [style({ opacity: 0 }), animate('0.3s ease-out', style({ opacity: 1 }))]),
//      query(':leave', [animate('0.1s ease-out', style({ opacity: 0 }))]),
//    ]),
//  ]),
//]);

export const routerFade = trigger('routerFade', [
  transition('* <=> *', [
    query(':leave', style({ position: 'fixed', width: '100%', zIndex: 99 }), { optional: true }),
    group([
      query(':enter', [style({ opacity: 0 }), animate('0.25s ease-out', style({ opacity: 1 }))], { optional: true }),
      query(':leave', [animate('0.2s ease-out', style({ opacity: 0 }))], { optional: true }),
      query('@*', animateChild(), { optional: true }),
    ]),
  ]),
]);
